<template>
  <div class="content" @click.self="_goBack()">
    <div class="authbox">
      <i-close class="close-icon" :size="20" @click.native="_goBack()" />
      <lang-selector class="auth" />
      <div class="error" v-if="error">
        {{ error }}
        <span><i-close :size="20" @click.native="$emit('errorClose')"/></span>
      </div>
      <div class="logo">
        <a href="/">
          <img src="@/assets/puti-logo.svg" alt="Putinomics" />
        </a>
      </div>
      <div class="header">{{ headerText }}</div>
      <form class="form" @submit.prevent="onSubmit">
        <slot></slot>
      </form>
      <template v-if="showSocials">
        <!-- <p class="loginSocials">{{ $t('auth.signvia') }}</p> -->
        <socials @telegramAuth="telegramAuth" />
      </template>
      <div class="loadingCurtain" v-if="loading">
        <span>{{ $t('auth.loading') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Socials from './socials'
import iclose from '@/components/icons/close'
import LangSelector from '@/components/Header/Navigation/LangSelector.vue'
import routingMixin from '@/utils/mixins/routingParams'

export default {
  name: 'AuthBase',
  mixins: [routingMixin],
  components: {
    socials: Socials,
    'i-close': iclose,
    'lang-selector': LangSelector,
  },
  props: {
    entry: {
      type: String,
      required: true,
      validator: (a) => {
        return ['login', 'registration', 'forgot', 'confirm'].indexOf(a) > -1
      },
    },
    'on-submit': {
      type: Function,
      required: true,
    },
    'telegram-auth': {
      type: Function,
      required: true,
    },
    error: {
      type: [String, Boolean],
      required: true,
    },
    headerText: {
      type: String,
      required: true,
      default: 'Login',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showSocials() {
      return ['login', 'registration'].indexOf(this.entry) > -1
    },
  },
  i18n: {
    messages: {
      en: require('@/locales/auth/en.json'),
      ru: require('@/locales/auth/ru.json'),
    },
  },
}
</script>

<style lang="scss">
:-webkit-autofill {
  animation-name: onAutoFillStart;
}
@keyframes onAutoFillStart {
  from {
  }
  to {
  }
}
.auth {
  &#app {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
    min-height: 0;
    color: rgba(0, 0, 0, 0.87);
    margin: 0;
    height: 100% !important;
  }
  .content {
    box-sizing: border-box;
    background-size: cover;
    background-position: center;
    background-color: black;
    min-height: 100%;
    min-width: 320px;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .authbox {
    font-size: 16px;
    line-height: 24px;
    font-family: PT Sans Caption;
    font-style: normal;
    font-weight: normal;
    position: relative;
    width: 516px;
    padding: 40px;
    border-radius: 20px;
    background-color: #ffffff;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12);
    margin: auto;

    // for lang-selector
    .dropdown {
      position: absolute;
      right: 0;
    }

    .logo img {
      width: 205px;
    }
    .header {
      font-weight: bold;
      font-size: 32px;
      line-height: 40px;
      color: #000000;
      flex: none;
      order: 1;
      flex-grow: 0;
      margin: 30px 0 0;
    }
    .field {
      margin-top: -9px;
    }
    .formgroup {
      margin: 23px 0 19px;
    }

    form {
      input,
      label {
        position: relative;
        display: inline-block;
        width: 100%;
      }

      label {
        display: inline-block;
        margin: 0 auto;
        padding: 0px 8px;
        width: auto;
        line-height: 16px;
        color: #9d9dbc;
        transition: all 0.4s ease-in-out, background 0.2s ease-in-out 0.2s;
        z-index: 7;
        top: 36px;
        left: 6px;
      }

      .filled label {
        padding: 0px 6px;
        top: 11px;
        font-size: 0.8em;
        background: #ffffff;
      }

      input.error {
        border-color: #d6005a;
      }
    }

    input {
      &[type='text'],
      &[type='password'] {
        font-size: 16px;
        z-index: 5;
        background: white;
        padding: 13px 12px 14px;
        border: 1px solid #c2c2d6;
        border-radius: 4px;
      }
      &[type='submit'] {
        padding: 15px 28px 13px;
        background: #ff6e51;
        border-radius: 4px;
        text-align: center;
        color: #ffffff;
        margin: 12px 0px;
        border: none;
        font-size: 17px;
      }
      &:-webkit-autofill {
        &:hover,
        &:focus,
        &:active {
          box-shadow: 0 0 0 30px white inset !important;
        }
        &::first-line {
          font-family: $primary-font;
          font-size: 16px;
        }
      }
    }

    p.consent {
      font-size: 0.8rem;
      line-height: 1rem;
      margin: 4px 0;
    }

    p.links {
      margin: 4px 0;
      font-size: 12px;
    }

    p.links a {
      color: #ff6e51;
      text-decoration: none;

      &:not(:last-child) {
        margin-right: 32px;
      }
    }

    .loginSocials {
      color: #8a8a8a;
      margin: 27px 0 1em;
    }

    div.error {
      background-color: #d6005a;
      position: absolute;
      width: 100%;
      top: 0;
      left: 0;
      transform: translateY(calc(-100% - 8px));
      padding: 20px 52px;
      color: #ffffff;
      border-radius: 8px;

      span {
        position: absolute;
        right: 20px;
        top: 20px;
        width: 20px;
        height: 20px;

        &:hover {
          cursor: pointer;
        }
      }
    }

    .loadingCurtain {
      background: rgba(255, 255, 255, 0.7);
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: inherit;
      z-index: 20;
      text-align: center;

      span {
        position: relative;
        display: inline-block;
        top: 50%;
        transform: translateY(-50%);
        font-size: 1.2em;
      }
    }

    .close-icon {
      position: absolute;
      top: -30px;
      right: -30px;
      cursor: pointer;
      path {
        stroke: white;
      }
    }
  }
  @media (max-width: 610px) {
    .content {
      background-color: white;
      display: block;
    }
    .authbox {
      width: 100%;
      box-shadow: none;
      padding: 24px 30px;
      font-size: 12px;

      .dropdown {
        transform: translate(0, 34px);
      }

      .logo img {
        width: 130px;
      }
      .header {
        margin: 15px 0 0;
        font-size: 24px;
      }
      .field {
        margin-top: -12px;
      }
      .formgroup {
        margin: -11px 0 19px;
      }

      form {
        label {
          top: 33px;
          left: 4px;
        }

        input[type='text'],
        input[type='password'] {
          padding: 8px 12px;
        }
        input[type='submit'] {
          font-size: inherit;
          padding: 8px 28px;
          margin: 2px 0 12px;
        }
      }

      .loginSocials {
        margin: 12px 0 1em;
      }

      div.error {
        position: absolute;
        width: calc(100% - 40px);
        margin: 20px;
        transform: none;
        padding: 12px 36px 12px 22px;
        border-radius: 8px;

        $closeSpanSize: 12px;
        span {
          right: $closeSpanSize;
          top: $closeSpanSize;
          width: $closeSpanSize;
          height: $closeSpanSize;
        }
      }

      .close-icon {
        top: 30px;
        right: 30px;
        path {
          stroke: #000000;
        }
      }
    }
  }
}
</style>
